var _widthNumbers;

import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var widths = {
  ONE: 'one',
  TWO: 'two',
  THREE: 'three',
  FOUR: 'four',
  FIVE: 'five',
  SIX: 'six',
  SEVEN: 'seven',
  EIGHT: 'eight',
  NINE: 'nine',
  TEN: 'ten',
  ELEVEN: 'eleven',
  TWELVE: 'twelve',
  THIRTEEN: 'thirteen',
  FOURTEEN: 'fourteen',
  FIFTEEN: 'fifteen',
  SIXTEEN: 'sixteen'
};
var widthNumbers = (_widthNumbers = {}, _widthNumbers[widths.ONE] = 1, _widthNumbers[widths.TWO] = 2, _widthNumbers[widths.THREE] = 3, _widthNumbers[widths.FOUR] = 4, _widthNumbers[widths.FIVE] = 5, _widthNumbers[widths.SIX] = 6, _widthNumbers[widths.SEVEN] = 7, _widthNumbers[widths.EIGHT] = 8, _widthNumbers[widths.NINE] = 9, _widthNumbers[widths.TEN] = 10, _widthNumbers[widths.ELEVEN] = 11, _widthNumbers[widths.TWELVE] = 12, _widthNumbers[widths.THIRTEEN] = 13, _widthNumbers[widths.FOURTEEN] = 14, _widthNumbers[widths.FIFTEEN] = 15, _widthNumbers[widths.SIXTEEN] = 16, _widthNumbers);

function toNumber(width) {
  return isNaN(width * 1) ? widthNumbers[width] : width;
}

widths = _reduceInstanceProperty(_).call(_, widths, function (acc, value, key) {
  acc[toNumber(value)] = value;
  return acc;
}, widths);
widths.ALL = _valuesInstanceProperty(_).call(_, widths);
widths.toNumber = toNumber;
export default widths;
//# sourceMappingURL=widths.js.map